import React, { useEffect, useState } from 'react';
import Keycloak from 'keycloak-js';
import axios from 'axios';
import AppRouter from './component/core/RouterComponent';
import UtilsService from './service/UtilsService';
import AdminService from './service/AdminService';
import CaseService from './service/CaseService';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Traductions from './traductions/traductions.json';
import TranscoUtils, { REF_LOCAL_ENUM, REF_ENUM } from './component/utils/TranscoUtils'
import UserUtils from './component/utils/UserUtils'
import { useLocation } from "react-router-dom";
import { env } from './env';
import RepairService from './service/RepairService';

const jwtDecode = require('jwt-decode');
const keycloak = new Keycloak({
    'url': env.REACT_APP_KEYCLOAK,
    'realm': 'ima-gc',
    'clientId': env.REACT_APP_KEYCLOAK_ID
});
// @ts-ignore
window.keycloak = keycloak;

const mapStateToProps = (state) => {
    return { aggrega: state.reduceAggrega.aggrega }
}

export default connect(mapStateToProps)(BeforeApp);
function BeforeApp(props) {
    const [isAuthent, setIsAuthent] = useState(false);
    const { t, i18n } = useTranslation('common');
    const query = new URLSearchParams(useLocation().search);
    // const cookies = new Cookies(null, { path: '/' });

    // Intercepteur pour placer dans le header des requetes le bearer avec le token de keycloak
    axios.interceptors.request.use(function (config) {
        config.headers['Authorization'] = 'Bearer ' + keycloak.token;
        config.headers['Accept-Language'] = localStorage.getItem('i18nextLng');
        return config;
    }, function (error) {
        console.error(error);
    });

    useEffect(() => {
        if (query.get("kc_idp_hint")) {
            let kcLogin = keycloak.login;
            keycloak.login = (options) => {
                options = options || {};
                options.idpHint = query.get("kc_idp_hint");
                kcLogin(options);
            };
        }

        // Initialisation de la langue de l'application
        initLanguage();

        keycloak.init({
            onLoad: 'login-required',
            checkLoginIframe: false,
            pkceMethod: 'S256'
        }).then(authenticated => {
            if (authenticated) {
                localStorage.setItem('token', keycloak.token);
                setIsAuthent(true);
                const userInfo = jwtDecode(keycloak.token);
                const codesClient = UserUtils.getCodeClientsByToken(userInfo);
                loadRef(userInfo, codesClient);
                const libellesClients = codesClient.map(code => TranscoUtils.getLabel(code, REF_ENUM.customer_codes));
                window.dataLayer.push({
                    clients: libellesClients
                });
                setInterval(() => {
                    keycloak.updateToken(5).then(function () {
                    }).catch(function () {
                        console.log('Failed to refresh the token, or the session has expired');
                        window.location.reload();
                    });
                }, 60000);
            } else {
                localStorage.setItem("roles", []);
            }
        }).catch(error => {
            console.log(error);
        });
    }, []);

    /**
     * Initialisation de la langue de l'application
     */
    const initLanguage = () => {
        let lang = localStorage.getItem('langRef');
        if (!lang) {
            // Récupération de la langue du navigateur
            lang = navigator.language.split(/[-_]/)[0];
        }
        // Si la langue fait partie des langues disponibles sur l'application
        const isValid = Traductions.find(f => f.language === lang);
        if (!isValid) {
            lang = 'fr'; // Francais par défaut
        }
        props.dispatch({ type: "UPDATE_LANG", lang: lang });
        localStorage.setItem('langRef', lang);
        i18n.changeLanguage(lang);
    }

    /**
     * Chargement des aggrégats et référentiels.
     */
    const loadRef = async (userInfo, codesClient) => {
        localStorage.setItem(REF_LOCAL_ENUM.status.value, JSON.stringify({ "ATR": t('STA_001'), "ENC": t('STA_002'), "TRA": t('STA_003') }));
        localStorage.setItem(REF_LOCAL_ENUM.roles.value, JSON.stringify({ "EXTC-ADMIN": t('ROL_001'), "EXTC-DATA": t('ROL_002'), "EXTC-DOSS": t('ROL_003'), "EXTC-MESS": t('ROL_004'), "EXTC-EMESS": t('ROL_005'), "EXTC-REPORTING": t('ROL_006'), "EXTC-TASK": t('ROL_007'), "EXTC-USER": t('ROL_008'), "EXTC-REPAIRS": t('ROL_009'), "EXTC-SUIVIGARANTIES": t('ROL_010'), "EXTC-DECISIONGARANTIES": t('ROL_011') }));
        localStorage.setItem(REF_LOCAL_ENUM.activities.value, JSON.stringify({ "DEP": t('ACT_001'), "HAB": t('ACT_002'), "MOB": t('ACT_003'), "SAN": t('ACT_004') }));
        localStorage.setItem(REF_LOCAL_ENUM.customers_types.value, JSON.stringify({ "AC": t('TYP_CUST_001'), "CO": t('TYP_CUST_002'), "LO": t('TYP_CUST_003'), "MO": t('TYP_CUST_004'), "SA": t('TYP_CUST_005') }));

        // Récupération des clients configuré pour utiliser l'extranet
        AdminService.getCutomers().then(res => {
            if (res && res.data) {
                let customers = [];
                res.data.filter(c => !c.disabled).forEach(c => {
                    const key = c.siteCode + c.customerCode;
                    if (codesClient.includes(key)) {
                        customers.push({ code: key, roles: c.roles, activities: c.activities, type: c.type, others: c.others, labelHolderId: c.labelHolderId })
                    }
                });

                // Si pas de clients on déconnecte l'utilisateur
                if (!customers || customers.length < 1) {
                    localStorage.setItem("roles", []);
                    // cookies.remove("token");
                    localStorage.setItem("token", undefined);
                    keycloak.logout();
                }

                localStorage.setItem("customersExt", JSON.stringify(customers));

                // initialisations des aggrgats
                initAggregates(customers, userInfo);
                initAggregatesSDR(customers, userInfo);
            }
        }).catch(error => {
        })

        if (userInfo && userInfo.uid) {
            AdminService.getUser(userInfo.uid).then((res) => {
                localStorage.setItem("displayName", res.data.displayName);
            })
        }

        // Chargement des référentiels
        await UtilsService.refreshRef(localStorage.getItem("langRef") ? localStorage.getItem("langRef") : "fr");

        // Rcupration des refrentiels locaux sur les codes clients disponible sur l'utilisateur
        UtilsService.fetchLocalReferentiel(codesClient).then(res => {
            let roles = [];
            if (res && res.data) {
                Object.values(res.data).forEach(client => {
                    if (client.activities) {
                        client.activities.forEach(a => {
                            const role = `${client.type}-${a}`;
                            if (!roles.includes(role)) {
                                roles.push(role);
                            }
                        })
                    }
                });
            }
            localStorage.setItem("customerRoles", JSON.stringify(roles));
        })
    }

    /**
     * Appel sans filtre pour récupérer les agrégats.
     * 
     */
    const initAggregates = (customers, userInfo) => {
        const customer = customers[0]?.code;
        const aggs = Object.values(REF_ENUM).filter(val => val.type === 'case').map(val => { return { data : val.value,  size: 1}});
        let emptyFilters = {
            configuration: {
                from: 0,
                size: 1,
                aggregat: aggs
            },
            filters: [
                {
                    data: '$.customer_code',
                    values: [customer],
                    operator: 'EQUAL'
                }
            ]
        }
        CaseService
            .fetchSearchCases(emptyFilters)
            .then((res) => {
                if (res && res.data && res.data.aggs) {
                    props.dispatch({ type: "RESET_FILTER" });
                    props.dispatch({ type: "INIT_AGGREGA", aggrega: res.data.aggs });

                    if (userInfo?.ima) {
                        let emptyFilters = {
                            configuration: {
                                from: 0,
                                size: 1,
                                aggregat: [{ data: "$.customer_code", size: 500 }]
                            },
                            filters: []
                        }
                        CaseService
                            .fetchSearchCases(emptyFilters)
                            .then((res) => {
                                if (res && res.data && res.data.cases) {
                                    // Maj des count de l'aggrega
                                    props.dispatch({ type: 'UPDATE', aggrega: res.data.aggs, filters: props.searchData, totalRows: res.data.total.value });
                                    props.dispatch({ type: "HIDE_LOADER" });
                                }
                            }).catch(error => {
                                props.dispatch({ type: "HIDE_LOADER" });
                            })
                    }
                }
            }).catch(error => {
            })
    }


    /**
     * Appel sans filtre pour récupérer les agrégats.
     * 
     */
    const initAggregatesSDR = (customers, userInfo) => {
        const customer = customers[0]?.code.substring(1, customers[0]?.code.length);
        let emptyFilters = {
            configuration: {
                from: 0,
                size: 1,
                aggregat: [{ data: "$.code_client", size: 1 },
                { data: "$.adresse_garage.libelle_garage", size: 1 },
                { data: "$.etat_avancement", size: 1 },
                { data: "$.mode_arrivee", size: 1 },
                { data: "$.type_mobilite", size: 1 },
                { data: REF_ENUM.garage_pays.value, size: 1 },
                { data: REF_ENUM.garage_departement.value, size: 1 },
                { data: "$.statut", size: 1 }]
            },
            filters: [
                {
                    data: '$.code_client',
                    values: [customer],
                    operator: 'EQUAL'
                }
            ]
        }
        RepairService
            .fetchSearchRepairs(emptyFilters)
            .then((res) => {
                if (res && res.data && res.data.aggs) {
                    props.dispatch({ type: "INIT_AGGREGA_SDR", aggrega: res.data.aggs });

                    if (userInfo?.ima) {
                        let emptyFilters = {
                            configuration: {
                                from: 0,
                                size: 1,
                                aggregat: [{ data: "$.code_client", size: 500 }]
                            },
                            filters: []
                        }
                        CaseService
                            .fetchSearchCases(emptyFilters)
                            .then((res) => {
                                if (res && res.data && res.data.cases) {
                                    // Maj des count de l'aggrega
                                    props.dispatch({ type: 'UPDATE_SDR', aggrega: res.data.aggs, filters: props.searchData, totalRows: res.data.total });
                                    props.dispatch({ type: "HIDE_LOADER" });
                                }
                            }).catch(error => {
                                props.dispatch({ type: "HIDE_LOADER" });
                            })
                    }
                }
            }).catch(error => {
            })
    }

    return (
        <>{isAuthent && <AppRouter keycloak={keycloak} />}</>
    );
}